import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ApiSender from './common/ApiLogic';

const preloadStyles = (code) => {
  const pathname = window.location.pathname;

  if (code && code === 2001 && pathname === '/lp/he') {
    const preloadCSS = document.createElement('link');
    preloadCSS.rel = 'preload';
    preloadCSS.as = 'style';
    preloadCSS.href = '/StylePage1711.css';
    preloadCSS.onload = function () {
      this.onload = null;
      this.rel = 'stylesheet';
    };
    document.head.appendChild(preloadCSS);
    return;
  }

  if ((code && code === 2002 && pathname === '/lp/he') || pathname === '/7564/pin') {
    const preloadCSS = document.createElement('link');
    preloadCSS.rel = 'preload';
    preloadCSS.as = 'style';
    preloadCSS.href = '/StylePage7564.css';
    preloadCSS.onload = function () {
      this.onload = null;
      this.rel = 'stylesheet';
    };
    document.head.appendChild(preloadCSS);
    return;
  }

  if ((code && code === 2003 && pathname === '/lp/he') || pathname === '/4309/pin') {
    const preloadCSS = document.createElement('link');
    preloadCSS.rel = 'preload';
    preloadCSS.as = 'style';
    preloadCSS.href = '/StylePage4309.css';
    preloadCSS.onload = function () {
      this.onload = null;
      this.rel = 'stylesheet';
    };
    document.head.appendChild(preloadCSS);
    return;
  }

  if ((code && code === 2004 && pathname === '/lp/he') || pathname === '/9173/pin') {
    const preloadCSS = document.createElement('link');
    preloadCSS.rel = 'preload';
    preloadCSS.as = 'style';
    preloadCSS.href = '/StylePage9173.css';
    preloadCSS.onload = function () {
      this.onload = null;
      this.rel = 'stylesheet';
    };
    document.head.appendChild(preloadCSS);
    return;
  }

  if (pathname === '/lp/he' || pathname === '/lp/pin' || pathname === '/lp/success' || pathname === '/lp/failed') {
    const preloadCSS = document.createElement('link');
    preloadCSS.rel = 'preload';
    preloadCSS.as = 'style';
    preloadCSS.href = '/StylePageMain.css';
    preloadCSS.onload = function () {
      this.onload = null;
      this.rel = 'stylesheet';
    };
    document.head.appendChild(preloadCSS);
  }
};

const init = async () => {
  const dcb = window.__DCB_PROTECT__ || { ti: null, ts: null, type: null };
  const urlParams = new URLSearchParams(window.location.search);
  const campaignId = urlParams.get("campaignId");

  let res = null;
  try {
    const apiLogic = new ApiSender();
    res = await apiLogic.getCampaign(campaignId);
  } catch (e) {
    console.error("getCampaign failed:", e);
  }

  const rootEl = document.getElementById("root");
  if (!rootEl) {
    console.error("Root element #root not found");
    return;
  }

  preloadStyles(res?.code);

  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <App
        ti={dcb.ti}
        ts={dcb.ts}
        camp={res?.code}
        params={urlParams}
      />
    </React.StrictMode>
  );
};

init();

reportWebVitals();
